<template>
    <a class="GoogleMapsLink" v-bind:href="Address.GoogleMapsWebSiteURL" target="_blank"><font-awesome-icon :icon="['fa', 'globe']" /></a>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faGlobe } from '@fortawesome/free-solid-svg-icons';
    library.add(faGlobe);

    export default {
        props: ["Address"],
        methods: {

        },
        components: {

        }
    }
</script>

<style scoped>
</style>